<template>
  <router-link :to="{ name: 'profile' }" class="router"
    ><button class="nav-btn">PROFILE</button>
  </router-link>
</template>

<script>
export default {
  name: "go-to-profile",
  methods: {},
};
</script>

<style scoped>
/* CSS for component in LeftNav.vue */
</style>